import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Accordion, Form } from 'react-bootstrap-5';

import { startsWith } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faTrash } from '@fortawesome/pro-solid-svg-icons';
import LocationOptions from './location_options';
import LocationForm from './location_form';
import LocationMap from './location_map';
import { NEW_LOCATION_ID_PREFIX } from './locations_constants';
import ManagedInput from 'components/form/managed_input';

const LocationPanel = ({ fullWidthMap, location, isOpen, stateOptions, googleMapsApiKey,
  onLocationChange, onRemove }) => {
  const clearBtnRef = useRef(null);

  const gePanelTitle = () => {
    const doNotHaveLocationInfo = !location.city && !location.state && !location.zip;
    if (location.name) return location.name;
    else if (location.polygonSearch) return 'Map Drawing';
    else if (startsWith(location.id, NEW_LOCATION_ID_PREFIX) && doNotHaveLocationInfo) return 'New Location';
    else if (doNotHaveLocationInfo) return 'No Location';

    const stateZip = [location.state, location.zip].filter(str => !!str).join(' ');
    return [location.city, stateZip].filter(str => !!str).join(', ');
  };

  const polygonSearch = location.polygonSearch;
  const panelTitle = gePanelTitle(location);

  return (
    <Accordion.Item eventKey={location.id}>
      <Accordion.Header>
        <div className="d-flex justify-content-between align-items-center w-100">
          <div>{panelTitle}</div>
          <FontAwesomeIcon 
            className="clickable ms-2 text-destructive" 
            icon={faTrash} 
            size="lg"
            onClick={(e) => {
              e.stopPropagation();
              onRemove && onRemove(location.id);
            }}
          />
        </div>
      </Accordion.Header>
      <Accordion.Body className="p-2">
        <Form.Group className="form-group">
          <Form.Label>Name</Form.Label>
          <div className="form-input-container">
            <ManagedInput
              className="form-control"
              name="name"
              placeholder="Location Name"
              value={location.name}
              onChange={({ name }) => onLocationChange({ ...location, name: name })}
            />
          </div>
        </Form.Group>
        <Row className="gx-0 mt-3">
          <Col md={fullWidthMap ? 12 : 4}>
            <LocationOptions
              clearBtnRef={clearBtnRef}
              location={location}
              onLocationChange={onLocationChange}
            />
          </Col>
          <Col
            className="bg-card p-3 border rounded"
            md={fullWidthMap ? 12 : 8}
          >
            {polygonSearch ?
              (isOpen &&
                <LocationMap
                  clearBtnRef={clearBtnRef}
                  googleMapsApiKey={googleMapsApiKey}
                  location={location}
                  onPolygonChange={newPolygon => onLocationChange({
                    ...location,
                    polygonGeojson: newPolygon
                  })}
                />) :
              <LocationForm location={location} stateOptions={stateOptions}
                onLocationChange={onLocationChange}
              />}
          </Col>
        </Row>
      </Accordion.Body>
    </Accordion.Item>
  );
};

LocationPanel.propTypes = {
  fullWidthMap: PropTypes.bool,
  googleMapsApiKey: PropTypes.string,
  isOpen: PropTypes.bool,
  location: PropTypes.object.isRequired,
  stateOptions: PropTypes.array.isRequired,
  onHeaderClick: PropTypes.func,
  onLocationChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func,
};

export default LocationPanel;
